import React from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CLIPBOARD_MENU_LABELS } from '../utils/annotationClipboardCopy';

const AnnotationClipboardMenu = ({
  anchorPosition,
  canCopy,
  canPaste,
  canDelete,
  deleteCount,
  onCopy,
  onPaste,
  onDelete,
  onClose,
}) => {
  const deleteLabel = deleteCount === 1
    ? 'Delete Block (删除方块)'
    : `Delete ${deleteCount} Blocks (删除 ${deleteCount} 个方块)`;

  return (
  <Menu
    open={Boolean(anchorPosition)}
    onClose={onClose}
    anchorReference="anchorPosition"
    anchorPosition={anchorPosition || undefined}
    MenuListProps={{ 'aria-label': 'Annotation clipboard actions (标注复制粘贴操作)', dense: true }}
    slotProps={{
      root: {
        sx: { pointerEvents: 'none' },
      },
      paper: {
        sx: {
          pointerEvents: 'auto',
          minWidth: 178,
          borderRadius: '10px',
          border: '1px solid #d7d9dd',
          boxShadow: '0 12px 28px rgba(25,30,38,.18)',
          mt: 0.5,
        },
      },
    }}
  >
    <MenuItem disabled={!canCopy} onClick={onCopy} aria-label={CLIPBOARD_MENU_LABELS.copy}>
      <ListItemIcon><ContentCopyOutlinedIcon fontSize="small" /></ListItemIcon>
      <ListItemText primary={CLIPBOARD_MENU_LABELS.copy} primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }} />
    </MenuItem>
    <MenuItem disabled={!canPaste} onClick={onPaste} aria-label={CLIPBOARD_MENU_LABELS.paste}>
      <ListItemIcon><ContentPasteOutlinedIcon fontSize="small" /></ListItemIcon>
      <ListItemText primary={CLIPBOARD_MENU_LABELS.paste} primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }} />
    </MenuItem>
    <MenuItem
      disabled={!canDelete}
      onClick={onDelete}
      aria-label={deleteLabel}
      sx={{ color: '#c62828', '& .MuiListItemIcon-root': { color: 'inherit' } }}
    >
      <ListItemIcon><DeleteOutlineIcon fontSize="small" /></ListItemIcon>
      <ListItemText primary={deleteLabel} primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }} />
    </MenuItem>
  </Menu>
  );
};

export default AnnotationClipboardMenu;
